import React, { useEffect, useState } from 'react'
import { globalGetService } from '../../../../globalServices';
import { checkApiStatus } from '../../../utils_v2';
import ConfigData from '../../master/components/ConfigData';
import { FormControl, FormControlLabel, Grid, Paper, Radio, RadioGroup, Tab, Table, TableBody, TableCell, TableHead, TableRow, Tabs, TextField, Tooltip, Typography } from '@material-ui/core';
import { Link } from 'react-router';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { PageLoader } from '../../../shared_elements';
import { numberWithCommas } from '../../../../utils';

const LlpPartView = () => {
    const [tabValue, setTabValue] = useState(0);
    const [llpPartViewInfo, setLlpPartViewInfo] = useState({});
    const [isLoading, setLoading] = useState(false);
    useEffect(() => {
      getLlpPartView();
    },[])
    const FrontendUrl = window.location.pathname;
    const path = FrontendUrl.split('/');
    const id = path[path.length-1];
    
    const getLlpPartView = (query) => {
      setLoading(true)
      globalGetService(`config-data/llp/${id}/`, query)
        .then(response => {
            if(checkApiStatus(response)) {
                setLlpPartViewInfo(response?.data?.data)
            }
            setLoading(false)
        })
    }
  return (
     <section className="asset-tech-specs" style={{ margin: '25px 0 0 75px' }}>
            <Paper className="tech-specs-card" style={{ height: `${window.innerHeight - 90}px` }}>
                <ConfigData />
                <div className="tech-specs-content" style={{ padding: "10px" }}>
                    <div style={{ display: "flex", alignItems: 'center' }}>
                        <Link to="/config-data/engineLlpsConfig/?llp-parts" fontSize="small" classname="back-icon" style={{ color: "#3F51B5" }}><ArrowBackIcon style={{ color: "#3F51B5", verticalAlign: 'top' }} /></Link>
                        <Typography variant="h7" >{llpPartViewInfo?.llp?.module?.name}</Typography>
                    </div>
                    <div className='console-management-modal' style={{ padding: "0px 10px" }}>
                        <Grid container spacing={1}>
                            <Grid item md={6} >
                                <TextField
                                    name='description'
                                    label='Description'
                                    disabled
                                    value={llpPartViewInfo?.llp?.description?.name || ''}
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={6} >
                                <TextField
                                    name='part_number'
                                    label='Part Number'
                                    disabled
                                    value={llpPartViewInfo?.llp?.part_number || ''}
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={12} >
                                <TextField
                                    name='remarks'
                                    label='Remarks'
                                    disabled
                                    value={llpPartViewInfo?.llp?.remarks || ''}
                                    fullWidth
                                    multiline
                                    rows={3}
                                    margin="normal"
                                    inputProps={{ maxLength: 255 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                          <Grid item md={6}>
                              <FormControl component="fieldset">
                                  <RadioGroup row aria-label="limitType" name="is_hour_cycle">
                                      <FormControlLabel value="is_hour_cycle" control={<Radio checked={llpPartViewInfo?.llp?.is_hour_cycle === "CY"} color="primary" size="small" />} label="Cycle Limit" />
                                      <FormControlLabel value="is_hour_cycle" control={<Radio checked={llpPartViewInfo?.llp?.is_hour_cycle === "HR"} color="primary" size="small" />} label="Hour Limit" />
                                  </RadioGroup>
                              </FormControl>
                          </Grid>
                        </Grid>
                    </div>
                  <Paper style={{ margin: "10px" }}>
                    <div style={{height: `${window.innerHeight - 395}px`, overflow: 'auto' }}>
                      <Table className='mui-table-format' stickyHeader>
                          <TableHead>
                              <TableRow>
                                  <TableCell><div style={{ width: "180px" }} >Engine Type</div></TableCell>
                                  <TableCell><div >{llpPartViewInfo?.llp?.is_hour_cycle === 'CY' ? 'Cycle' : 'Hour'} Limit</div></TableCell>
                                  <TableCell><div >Escalation %</div></TableCell>
                                  <TableCell><div >Replacement Cost ($)</div></TableCell>
                                  <TableCell><div >Year of Cost</div></TableCell>
                              </TableRow>
                          </TableHead>
                          <TableBody>
                              {llpPartViewInfo?.llp?.linked_engine?.map((item, index) =>
                                  <TableRow key={index} style={{ verticalAlign: 'text-bottom' }}>
                                      <TableCell style={{ alignContent: 'center' }}><Link to={`/config-data/engineType/View/${item?.engine_type?.id}`}><Tooltip title="On Clicking on this it will redirect to engine type detail"><div style={{ width: "180px", textDecoration:"underline" }}>{item?.engine_type?.name}</div></Tooltip></Link></TableCell>
                                      <TableCell style={{ alignContent: 'center' }}><div >{numberWithCommas(item?.limit)}</div></TableCell>
                                      <TableCell style={{ alignContent: 'center' }}><div >{item?.escalation_percentage}</div></TableCell>
                                      <TableCell style={{ alignContent: 'center' }}><div >{numberWithCommas(item?.cost)}</div></TableCell>
                                      <TableCell style={{ alignContent: 'center' }}><div >{item?.year_of_cost}</div></TableCell>
                                  </TableRow>)}
                          </TableBody>
                      </Table>
                      </div>
                  </Paper>
                </div>
            </Paper>
            {isLoading ? <PageLoader /> : null}
        </section>
  )
}
export default LlpPartView





